'use client';import{c as _c}from"react/compiler-runtime";import{createContext,useContext,useMemo,ReactNode}from'react';import type{AnalyticsTargetArea}from'@/app/types/analytics';export interface InteractionAreaState{targetArea:AnalyticsTargetArea|undefined;}const initialState:InteractionAreaState={targetArea:undefined};const InteractionAreaContext=createContext<InteractionAreaState>(initialState);interface InteractionAreaProviderProps{children:ReactNode;targetArea:AnalyticsTargetArea;}/**
 * Provider component that sets the interaction area for analytics tracking.
 *
 * Wrap sections of your UI with this provider to specify the target area
 * for all analytics events triggered within.
 *
 * @example
 * ```tsx
 * function Sidebar() {
 *   return (
 *     <InteractionAreaProvider targetArea="side_nav">
 *       <SidebarContent />
 *     </InteractionAreaProvider>
 *   );
 * }
 * ```
 */export function InteractionAreaProvider(t0){const $=_c(5);const{children,targetArea}=t0;let t1;if($[0]!==targetArea){t1={targetArea};$[0]=targetArea;$[1]=t1;}else{t1=$[1];}const value=t1;let t2;if($[2]!==children||$[3]!==value){t2=<InteractionAreaContext.Provider value={value}>{children}</InteractionAreaContext.Provider>;$[2]=children;$[3]=value;$[4]=t2;}else{t2=$[4];}return t2;}/**
 * Hook to access the current interaction area context.
 * Returns the targetArea from the nearest InteractionAreaProvider ancestor.
 *
 * @returns The current interaction area state, including the targetArea (if any).
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { targetArea } = useInteractionArea();
 *
 *   if (targetArea) {
 *     console.log(`Currently in area: ${targetArea}`);
 *   }
 *
 *   return <div>...</div>;
 * }
 * ```
 */export function useInteractionArea(){return useContext(InteractionAreaContext);}export default InteractionAreaContext;